import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["scheduledEmailId"];
import http from 'hub-http/clients/apiClient';
import { registerMutation, registerQuery } from 'data-fetching-client';
const SEND_ASSET_BASE_URL = 'dashboard/v1/email/dashboard';
const SCHEDULE_ASSET_BASE_URL = 'dashboard/v1/report-emails';

// Mutation/Query field names (for caching)
const SEND_ASSET_NOW_FIELD_NAME = 'sendAssetNow';
const CREATE_ASSET_SCHEDULE_FIELD_NAME = 'createAssetSchedule';
const EDIT_ASSET_SCHEDULE_FIELD_NAME = 'editAssetSchedule';
const DELETE_ASSET_SCHEDULE_FIELD_NAME = 'deleteAssetSchedule';
export const SHARE_ASSET_SCHEDULES_FIELD_NAME = 'emailSchedules';
export const CONNECTED_EMAIL_SENDING_DOMAINS_FIELD_NAME = 'connectedEmailSendingDomains';
export const REPORT_OBJECT_TYPE = 'REPORT';
export const DASHBOARD_OBJECT_TYPE = 'DASHBOARD';
const sendAssetNow = payload => {
  return http.post(SEND_ASSET_BASE_URL, {
    data: Object.assign({}, payload)
  });
};
const createAssetSchedule = ({
  deliveryType,
  objectType,
  objectId,
  subject,
  message,
  nickname,
  ownerId,
  exportType,
  queryString,
  reportsPerPage,
  recipientUserIds,
  scheduleFrequency,
  scheduledOnDays,
  scheduledAtHour,
  recipientDestination,
  filterId
}) => {
  return http.post(`${SCHEDULE_ASSET_BASE_URL}/schedule`, {
    data: {
      deliveryType,
      objectType,
      objectId,
      subject,
      message,
      nickname,
      ownerId,
      exportType,
      queryString,
      reportsPerPage,
      recipientUserIds,
      scheduleFrequency,
      scheduledOnDays,
      scheduledAtHour,
      recipientDestination,
      filterId
    }
  });
};
const editAssetSchedule = _ref => {
  let {
      scheduledEmailId
    } = _ref,
    editPayload = _objectWithoutPropertiesLoose(_ref, _excluded);
  return http.put(`${SCHEDULE_ASSET_BASE_URL}/${scheduledEmailId}`, {
    data: editPayload
  });
};
const deleteAssetSchedule = ({
  scheduleId
}) => {
  return http.delete(`${SCHEDULE_ASSET_BASE_URL}/${scheduleId}`);
};
const getShareAssetSchedules = payload => {
  return http.get(`dashboard/v1/report-emails`, {
    query: Object.assign({}, payload)
  });
};
const getConnectedEmailSendingDomains = () => {
  return http.get(`email-mta-sending/v1/auth-domains/connected-email-sending-domains`);
};
const getShareIdsByDashboard = () => {
  return http.get('dashboard/v1/report-emails/all-ids-by-dashboard');
};
export const SEND_ASSET_NOW = registerMutation({
  fieldName: SEND_ASSET_NOW_FIELD_NAME,
  args: ['deliveryType', 'objectType', 'objectId', 'subject', 'message', 'queryString', 'exportType', 'reportsPerPage', 'recipientUserIds', 'externalRecipientEmails', 'recipientDestination', 'filterId'],
  fetcher(payload) {
    return sendAssetNow(payload);
  }
});
export const CREATE_ASSET_SCHEDULE = registerMutation({
  fieldName: CREATE_ASSET_SCHEDULE_FIELD_NAME,
  args: ['deliveryType', 'objectType', 'objectId', 'subject', 'message', 'nickname', 'ownerId', 'exportType', 'queryString', 'reportsPerPage', 'recipientUserIds', 'scheduleFrequency', 'scheduledOnDays', 'scheduledAtHour', 'recipientDestination', 'filterId'],
  fetcher(payload) {
    return createAssetSchedule(payload);
  }
});
export const EDIT_ASSET_SCHEDULE = registerMutation({
  fieldName: EDIT_ASSET_SCHEDULE_FIELD_NAME,
  args: ['deliveryType', 'scheduledEmailId', 'objectType', 'objectId', 'subject', 'message', 'nickname', 'ownerId', 'exportType', 'queryString', 'reportsPerPage', 'recipientUserIds', 'scheduleFrequency', 'scheduledOnDays', 'scheduledAtHour', 'recipientDestination', 'filterId'],
  fetcher({
    deliveryType,
    scheduledEmailId,
    objectType,
    objectId,
    subject,
    message,
    nickname,
    ownerId,
    exportType,
    queryString,
    reportsPerPage,
    recipientUserIds,
    scheduleFrequency,
    scheduledOnDays,
    scheduledAtHour,
    recipientDestination,
    filterId
  }) {
    return editAssetSchedule({
      deliveryType,
      scheduledEmailId,
      objectType,
      objectId,
      subject,
      message,
      nickname,
      ownerId,
      exportType,
      queryString,
      reportsPerPage,
      recipientUserIds,
      scheduleFrequency,
      scheduledOnDays,
      scheduledAtHour,
      recipientDestination,
      filterId
    });
  }
});
export const DELETE_ASSET_SCHEDULE = registerMutation({
  fieldName: DELETE_ASSET_SCHEDULE_FIELD_NAME,
  args: ['scheduleId'],
  fetcher(payload) {
    return deleteAssetSchedule(payload);
  }
});
export const GET_SHARE_ASSET_SCHEDULE = registerQuery({
  fieldName: SHARE_ASSET_SCHEDULES_FIELD_NAME,
  args: ['objectId', 'objectType', 'deliveryType'],
  fetcher(payload) {
    return getShareAssetSchedules(payload);
  }
});
export const GET_CONNECTED_EMAIL_SENDING_DOMAINS = registerQuery({
  fieldName: CONNECTED_EMAIL_SENDING_DOMAINS_FIELD_NAME,
  args: [],
  fetcher() {
    return getConnectedEmailSendingDomains();
  }
});
export const GET_SHARE_IDS_BY_DASHBOARD = registerQuery({
  fieldName: 'shareIdsByDashboard',
  args: [],
  fetcher() {
    return getShareIdsByDashboard();
  }
});